namespace Queries {
    interface IUserQueryFilter
        extends IQueryFilter {

    }

    export class UserQuery
        implements ITQueryInfo<Indexes.User, Entities.User, IUserQueryFilter, Entities.User> {
        
        
        private _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }

        async execute(context: ITQueryRequestContext<Indexes.User, Entities.User>) {
            const { results: results, stats: stats } = await this._repository.queryDocuments<Entities.User>("users", "", {}, context.from, context.limit)

            return {
                docs: results,
                totalResults: stats.totalResults
            }
        }

        // async execute(context: ITQueryRequestContext<Indexes.User, Entities.User>) {
        //     let query = this._query;
        //     if (context.filter.input != null)
        //         query = query.whereContainsAll("byQuery", context.filter.input.split(" ").filter(Boolean));
        //     var result  = await query
        //         .orderBy(context.orderBy ?? "byLastName")
        //         .skip(context.from)
        //         .limit(context.limit)
        //         .toArray();
        //     return {
        //         docs: result.docs,
        //         totalResults: result.totalResults
        //     }
        // }
    }
}